import $ from "jquery";

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

let SwiperPopup = $('.swiper-slider-popup');
let appendSwiper = SwiperPopup.find('#append');

const options = {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    // ARIA
    a11y: {
        prevSlideMessage: 'Bekijk de vorige',
        nextSlideMessage: 'Bekijk de volgende',
    }
};
new Swiper('.swiper-container-small', options);
new Swiper('.swiper-container-large', $.extend({}, options, {
    autoplay: {
        delay: 5000,
    },
    effect: 'fade',

    speed: 700,
    fadeEffect: {
        crossFade: true,
    }
}));

SwiperPopup.on('click', function (e) {
    let target = $(e.target);
    if (target.closest('.swiper-slider-popup-item').length !== 0 && !target.closest('.swiper-button-close').length) {
        return false;
    }

    SwiperPopup.find('.swiper-container').remove();
    SwiperPopup.removeClass('init');
});

$('[data-swiper]').on('click', function () {
    SwiperPopup.addClass('init');

    // Clone the entire structure and preserve the wrapper
    const $originalContainer = $(this).closest('.swiper-container');
    const $clone = $originalContainer.clone();

    // Clean up existing container
    appendSwiper.find('.swiper-container').remove();

    // Prepare the cloned container
    $clone.find('.card').removeClass('card card-border');
    $clone.addClass('card--white');

    // Append to target
    appendSwiper.append($clone);

    new Swiper($clone[0], {
        ...options,
        initialSlide: $originalContainer.find('.swiper-slide').index(this),
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    });
});

$('[data-swiper-single]').on('click', function () {
    SwiperPopup.addClass('init swiper-single');
    let $clone = $(this).clone();

    appendSwiper.find('.swiper-container').remove();
    appendSwiper.append($clone);

    let swiper = appendSwiper.find('.swiper-container');

    swiper.find('.card').removeClass('card card-border');
    swiper.addClass('card--white');
});

const galleryThumbs = new Swiper('.gallery-thumbs', {
    touchRatio: 0,
    spaceBetween: 15,
    slidesPerView: 'auto',
    centeredSlides: true,
    slideToClickedSlide: true,
    watchSlidesProgress: true,
    loop: false,
    navigation: {
        nextEl: '.gallery-thumbs-next',
        prevEl: '.gallery-thumbs-prev',
    },
    breakpoints: {
        1460: {
            spaceBetween: 10,
            slidesPerView: 'auto',
        },
        768: {
            spaceBetween: 5,
            slidesPerView: 'auto',
        }
    },
    // Add controller to sync with top gallery
    on: {
        click: function (swiper) {
            if (galleryTop) {
                galleryTop.slideTo(swiper.clickedIndex);
            }
            if (galleryThumbs) {
                galleryThumbs.slideTo(swiper.clickedIndex);
            }
        },
        slideChange: function () {
            if (galleryTop) {
                galleryTop.slideTo(this.activeIndex);
            }
            if (galleryThumbs) {
                galleryThumbs.slideTo(this.activeIndex);
            }
        }
    }
});

const galleryTop = new Swiper('.gallery-top', {
    slidesPerView: 1,
    touchRatio: 0,
    spaceBetween: 10,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    loop: false,
    thumbs: {
        swiper: galleryThumbs,
    },
    on: {
        slideChange: function () {
            if (galleryThumbs) {
                galleryThumbs.slideTo(this.activeIndex);
            }
        }
    }
});

if (document.getElementsByClassName('js-quote').length > 0) {
    const quoteConfig = window.QuoteConfig ?? {};
    const slides_per_view_default = quoteConfig.slides_per_view_default ?? 4;
    const slides_per_view_breakpoint_768 = quoteConfig.slides_per_view_breakpoint_768 ?? 1;
    const slides_per_view_breakpoint_992 = quoteConfig.slides_per_view_breakpoint_992 ?? 2;
    const slides_per_view_breakpoint_1260 = quoteConfig.slides_per_view_breakpoint_1260 ?? 3;
    const slides_per_view_breakpoint_1460 = quoteConfig.slides_per_view_breakpoint_1460 ?? 4;
    const quoteSwiperOptions = {
        loop: true,
        navigation: {
            nextEl: '.quote-button-next',
            prevEl: '.quote-button-prev',
        },
        slidesPerView: slides_per_view_default,
        breakpoints: {
            768: {
                slidesPerView: slides_per_view_breakpoint_768,
            },
            992: {
                slidesPerView: slides_per_view_breakpoint_992,
            },
            1260: {
                slidesPerView: slides_per_view_breakpoint_1260,
            },
            1460: {
                slidesPerView: slides_per_view_breakpoint_1460,
            },
        },
        autoplay: {
            delay: 2000,
        },
    };
    new Swiper('.js-quote', quoteSwiperOptions);
}